// src/pages/History/20thCentury/AfricanIndependence.jsx
import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/20th_Century_-_African_Independence_Movements.png';

function HistoryPageAfricanIndependence() {
  return (
    <TopicPage
      topicKey="African Independence Movements"
      title="History: African Independence Movements"
      backgroundImage={bg}
      startRoute="/History-African-Independence-Go"
      scrollLabels={[
        "Colonial Rule in Africa",
        "Key Leaders and Movements",
        "Challenges After Independence",
      ]}
      backRoute="/history-20th-century"
      backLabel="← Return to topics"
      backButtonClassName="journey-button special"
      backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}

export default HistoryPageAfricanIndependence;
